
$(document).scroll(function () {
    if (!$('#newsdetail').length) {
        return
    }
    var topScroll = jQuery(window).scrollTop();
    let inner = window.innerHeight;
    if ($('.maintitle').offset().top - topScroll <= inner) {
        $('.maintitle').addClass('animated fadeInUp')
    }
    if ($('.mainlist').offset().top - topScroll <= inner) {
        $('.hhh').addClass('animation-scale-up')
    }
    if ($('.newsimglist').offset().top - topScroll <= inner) {
        $('.mainimgitem').addClass('animated fadeInUp')
    }
})


//////////////////
// WEBPACK FOOTER
// ./utils/news-detail.js
// module id = 9VQK
// module chunks = 1